"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function defer() {
  var reject;
  var resolve;
  var promise = new Promise(function (fst, snd) {
    resolve = fst;
    reject = snd;
  });
  return {
    promise: promise,
    reject: reject,
    resolve: resolve
  };
}

var _default = defer;
exports.default = _default;
module.exports = exports.default;